<template>
  <div>
    <!-- 開局選單 -->
    <van-overlay :show="data.active" @click="data.active = false">
      <div class="wrapper">
        <div class="block">
          <van-button
            class="buttonListItem"
            round
            type="info"
            v-for="(btn,index) in buttonList"
            :key="index"
            @click="btn.fun()"
            :disabled="btn.disabled"
          >{{btn.name}}</van-button>
        </div>
      </div>
    </van-overlay>
    <!-- 快速開局表單 -->
    <!-- @click="showquckileyStartOpen = false" -->
    <van-overlay :show="showquckileyStartOpen">
      <div class="wrapper">
        <div class="block">
          <van-form @submit="onSubmit">
            <van-field
              v-model="game_name"
              name="球賽名稱"
              label
              placeholder="球賽名稱"
              left-icon="flag-o"
              :rules="[{ required: true, message: '請填寫球賽名稱' }]"
            />

            <van-field
              readonly
              clickable
              name="球場名稱"
              label
              :value="course_name"
              placeholder="點擊選擇球場名稱"
              left-icon="location-o"
              @click="showArea = true"
              :rules="[{ required: true, message: '請點擊選擇球場名稱' }]"
            />
            <van-field name="radio">
              <template #input>
                <van-radio-group v-model="private_game_radio" direction="horizontal">
                  <van-radio name="1">公開開局</van-radio>
                  <van-radio name="2">私人開局</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <div style="margin: 16px;width: 32%;display: inline-block;">
              <van-button
                @click="showquckileyStartOpen = false"
                round
                block
                type="info"
                native-type="button"
                style="{width: 100%;display: inline-block;}"
              >取消</van-button>
            </div>
            <div style="margin: 16px;width: 32%;display: inline-block;float: right;">
              <van-button
                round
                block
                type="info"
                native-type="submit"
                style="{width: 100%;display: inline-block;}"
              >確定</van-button>
            </div>
          </van-form>
        </div>
      </div>
    </van-overlay>
    <!-- 快速開局 選擇球場區域 -->
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        confirm-button-text="確定"
        @confirm="onAreaConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Notify } from "vant";
import { firebase } from "../firebase/firebase";
import { mapGetters } from "vuex";
import courseSelect from "../assets/json/courseSelect.json";
import moment from "moment";
export default {
  data() {
    return {
      areaList: courseSelect,
      game_name: "",
      course_name: "",
      private_game_radio: "1",
      private_game: false,
      showArea: false,
      showquckileyStartOpen: false,
      buttonList: [
        {
          name: "一般開局",
          fun: () => this.$router.push({ name: "gameOpenInfo" }),
        },
        {
          name: "只要計分",
          fun: () => {
            Notify({ type: "primary", message: "選擇球場後開始使用計分卡" });
            this.showquckileyStartOpen = true;
          },
        },
        { name: "特殊玩法", fun: () => console.log("hi"), disabled: true },
      ],
    };
  },
  props: ["data"],
  computed: {
    ...mapGetters(["liffUserData"]),
  },
  methods: {
    async onSubmit() {
      this.private_game = this.private_game_radio == "1" ? true : false;
      const timeObject = new Date();
      this.open_date = moment(timeObject).format("YYYY-MM-DD");
      this.open_time = moment(timeObject).format("hh:mm");
      const key = firebase.database().ref("competes").push().key;
      const data = await firebase
        .database()
        .ref(`courses/${this.course_name}`)
        .once("value");
      const { score_card, courseImageUrl } = data.val();
      const competeData = {
        course_name: this.course_name,
        game_name: this.game_name,
        game_price: 0,
        open_date: this.open_date,
        open_time: this.open_time,
        rewards: "",
        sets: 1,
        private_game: this.private_game,
        competeOrder: {
          [this.liffUserData.userId]: { time: new Date().getTime(), group: 1 },
        },
        userId: this.liffUserData.userId,
        key: key.substring(key.length - 3, key.length),
        groupId: "NoGroupIdOpen",
        allKey: key,
        quicklyStart: true,
        area: {
          1: Object.keys(score_card)[0],
          2: Object.keys(score_card)[1],
        },
        img: courseImageUrl,
      };
      Dialog.confirm({
        title: "計分卡",
        message: `確定快速建立 ${this.course_name} 球場的計分卡?`,
        confirmButtonText: "確認",
      })
        .then(() => {
          firebase.database().ref(`competes/${key}`).update(competeData);
          firebase
            .database()
            .ref("user-games/" + this.liffUserData.userId + "/" + key)
            .set(1);
          firebase
            .database()
            .ref(`group-competes/NoGroupIdOpen/${key}`)
            .set(timeObject.getTime());
          Dialog.close();
        })
        .then(() => {
          Dialog.alert({ message: "開局成功" });
        })
        .then(() => {
          Dialog.close();
          this.showquckileyStartOpen = false;
          this.$router.replace(`/gameRecordCard/${key}`);
        });
    },
    onAreaConfirm(values) {
      this.course_name = values[2]["name"];
      this.showArea = false;
    },
  },
};
</script>

<style>
</style>